import { ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledContainer = styled.div`
  display: flex;
  width: 95px;
  flex-direction: column;
  align-items: center;
  margin: auto;

  & > :first-child {
    margin-bottom: 8px;
  }

  & > :last-child {
    width: 100%;
    min-height: 32px;
    margin-bottom: 8px;
    text-align: center;
    word-wrap: break-word;
  }
`

export const StyledImage = styled.div`
  display: flex;
  width: 95px;
  height: 95px;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(props: ThemeProps) => props.theme.colors.neutral100};
  //padding: 16px;
  background: ${(props: ThemeProps) => props.theme.colors.white};
  border-radius: 6px;

  & > img {
    width: 55px;
    height: 55px;
  }
`

export const StyledCaption = styled.div`
  color: ${(props: ThemeProps) => props.theme.colors.gray800};
  font-size: ${(props: ThemeProps) => props.theme.sizes.fsCaption2};
  font-weight: ${(props: ThemeProps) => props.theme.sizes.fwBold};
  line-height: 16px;
  text-decoration: none;
`
